<div class="ion-padding" (click)="dismiss()">
  <!--<script type="module" src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.esm.js"></script>
  <script nomodule src="https://unpkg.com/ionicons@5.5.2/dist/ionicons/ionicons.js"></script>
  -->
  <!--|| Main Container ||-->
  <div class="pageContainer">

    <!--|| Header ||-->
    <div class="logoContainer">
      <ion-icon class="backButton" name="chevron-back-outline" (click)="dismiss()"></ion-icon>
    </div>

    <!--||'VegMatch' Container ||-->
    <div class="matchTextContainer animate-from-bottom">
      <span>{{'itsAMatch' | translate}}</span>
    </div>

    <div class="matchSubTextContainer animate-from-bottom">
      <span>{{ likedSoul.firstName }} {{'likedYouToo' | translate}}</span>
    </div>

    <!--|| Matches's Pictures ||-->
    <div class="soulsContainer">

      <!--| User |-->
      <div class="soulsBackground top animate-from-left">
        <div class="soulsMatch top">
          <img src="{{this.userData?.profilePic}}">
        </div> 
      </div>
      
      <!--| Match |-->
      <div class="soulsBackground bottom animate-from-right">
        <div class="soulsMatch bottom">
          <img [src]="this.likedSoul.firstPic">
        </div>  
      </div>

    </div>

    <!--|| Footer Buttons Container ||-->
    <div class="btnContainer">

      <!--| Chat |-->
      <div class="btn chat"  (click)="chat(this.likedSoul)">
        <ion-icon name="chatbubbles" class="chatIcon"></ion-icon>
        <span class="btnText chat">{{'chat' | translate}}</span>
      </div>
    </div>
  </div>

</div>